export default __webpack_public_path__ + "static/media/circle2.71bb6e5c.svg";